import { Field, FieldArray, Form, Formik } from "formik";
import { Form as BForm, Card, Col, Row } from "react-bootstrap";
import TextInput from "../../../../../components/formfields/InputField";
import featureImg from "../../../../../assets/images/feature-img.png";
import { useCallback, useEffect, useRef, useState } from "react";
import AddFeatureModal from "./AddFeatureModal";
import ColorPicker, { useColorPicker } from "react-best-gradient-color-picker";
import { toolType } from "../types";
import * as Yup from "yup";
import useClickOutside from "../../../../../hooks/useClickOutside";
import SubmitLoader from "../../../../../components/SubmitLoader";

const FeauterItem = ({ item, arrayHelpers, uploadAction, setFieldValue, idx, uploadNewAction }: any) => {
  const [showEditFeature, setShowEditFeature] = useState<boolean>(false);

  return (
    <tr>
      <td>
        <h4 className="td-title">{item.title}</h4>
        <p className="mb-0">{item.description}</p>
      </td>
      <td className="text-center">
        <div className="featureImage d-flex align-items-center justify-content-center">
          <img src={item.dummyImage || item.image ? item.dummyImage || item.image : featureImg} alt="" />
        </div>
      </td>

      <td className="text-center actions">
        <div className="d-flex align-items-center justify-content-center">
          <a className="mx-1" onClick={() => setShowEditFeature(true)}>
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.9263 14.1041H6.77809C6.55401 14.1041 6.37068 14.2874 6.37068 14.5115C6.37068 14.7356 6.55401 14.9189 6.77809 14.9189H14.9263C15.1512 14.9189 15.3337 14.7365 15.3337 14.5115C15.3337 14.2874 15.1503 14.1041 14.9263 14.1041ZM13.2253 3.31438L12.2702 2.35927C11.9522 2.04103 11.5346 1.88184 11.1195 1.88184C10.7024 1.88184 10.2854 2.04098 9.96707 2.35927L1.8156 10.5113C1.59743 10.7294 1.44562 11.005 1.37815 11.306L0.675112 14.4328C0.623676 14.6668 0.823765 14.9189 1.0731 14.9189C1.09976 14.9189 1.12698 14.9163 1.15453 14.9107C1.15453 14.9107 3.30895 14.4537 4.28139 14.225C4.57523 14.1558 4.83826 14.008 5.05164 13.7947L13.2304 5.61598C13.8644 4.98068 13.8619 3.95096 13.2253 3.31438ZM4.47368 13.218C4.36626 13.3254 4.2381 13.3972 4.09276 13.4314C3.46433 13.5794 2.31951 13.8274 1.61113 13.9794L2.17234 11.4838C2.20625 11.3331 2.2819 11.1958 2.39117 11.0865L8.69581 4.78189L10.8031 6.88921L4.47368 13.218ZM12.6524 5.03925L11.3785 6.31291L9.27117 4.20559L10.5425 2.93422C10.6968 2.78144 10.9005 2.69665 11.1195 2.69665C11.3385 2.69665 11.5417 2.78144 11.6958 2.93537L12.6509 3.89049C12.9681 4.20839 12.9681 4.72351 12.6524 5.03925Z"
                fill="#071446"
              />
            </svg>
          </a>
          {showEditFeature && (
            <AddFeatureModal
              show={showEditFeature}
              setShow={setShowEditFeature}
              editData={item}
              customArrayHelper={arrayHelpers}
              uploadAction={uploadAction}
              setFieldValue={setFieldValue}
              index={idx}
              uploadNewAction={uploadNewAction}
            />
          )}
          <a onClick={() => arrayHelpers.remove(idx)} className="mx-1">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.958 2.90072H11.208L10.2446 1.61882C9.9877 1.27148 9.57806 1.06738 9.14551 1.06738H6.85384C6.42129 1.06738 6.01165 1.27148 5.75384 1.61882L4.79134 2.90072H2.04134C1.78929 2.90072 1.58301 3.10697 1.58301 3.35905C1.58301 3.6111 1.78929 3.81738 2.04134 3.81738H13.958C14.2101 3.81738 14.4163 3.6111 14.4163 3.35905C14.4163 3.10697 14.2101 2.90072 13.958 2.90072ZM5.93717 2.90072L6.48861 2.16681C6.57598 2.05223 6.71061 1.98405 6.85384 1.98405H9.14551C9.28874 1.98405 9.4248 2.05208 9.51074 2.16667L10.0622 2.90072H5.93717ZM13.0413 4.73405C12.7893 4.73405 12.583 4.9403 12.583 5.19238V13.4424C12.583 14.2006 11.9663 14.8174 11.208 14.8174H4.79134C4.03309 14.8174 3.41634 14.2015 3.41634 13.4424V5.19238C3.41634 4.9403 3.21124 4.73405 2.95801 4.73405C2.70478 4.73405 2.49967 4.9403 2.49967 5.19238V13.4424C2.49967 14.7057 3.52777 15.734 4.79134 15.734H11.208C12.4716 15.734 13.4997 14.7059 13.4997 13.4424V5.19238C13.4997 4.9403 13.2934 4.73405 13.0413 4.73405ZM5.70801 12.984V6.56738C5.70801 6.31404 5.50302 6.10905 5.24967 6.10905C4.99633 6.10905 4.79134 6.3153 4.79134 6.56738V12.984C4.79134 13.2374 4.99633 13.4424 5.24967 13.4424C5.50302 13.4424 5.70801 13.2361 5.70801 12.984ZM8.45801 12.984V6.56738C8.45801 6.31404 8.25302 6.10905 7.99967 6.10905C7.74633 6.10905 7.54134 6.3153 7.54134 6.56738V12.984C7.54134 13.2374 7.74633 13.4424 7.99967 13.4424C8.25302 13.4424 8.45801 13.2361 8.45801 12.984ZM11.208 12.984V6.56738C11.208 6.31404 11.003 6.10905 10.7497 6.10905C10.4963 6.10905 10.2913 6.3153 10.2913 6.56738V12.984C10.2913 13.2374 10.4963 13.4424 10.7497 13.4424C11.003 13.4424 11.208 13.2361 11.208 12.984Z"
                fill="#071446"
              />
            </svg>
          </a>
        </div>
      </td>
    </tr>
  );
};

type editToolType = {
  index: number;
  tool: toolType;
  dummyImage?: any;
  oldImage?: any;
};
type AddToolProps = {
  uploadAction?: any;
  editTool?: editToolType | null;
  setEditTool?: any;
  customHelpers?: any;
  setFieldValue?: any;
  edit: boolean;
  uploadNewAction?: any;
};

export const AddTools = ({ uploadAction, customHelpers, editTool, setEditTool, setFieldValue, edit, uploadNewAction }: AddToolProps) => {
  const [showAddFeature, setShowAddFeature] = useState<boolean>(false);
  const [showPicker, setShowPicker] = useState<boolean>(false);
  const [color, setColor] = useState<string>("linear-gradient(140deg, rgb(198, 255, 221) 0%, rgb(251, 215, 134) 59%, rgb(247, 121, 125) 100%)");
  useColorPicker(color, setColor);
  const myRef = useRef(null);

  const handleClickOutside = () => {
    setShowPicker(false);
    // handle outside click here
  };
  useClickOutside(myRef, handleClickOutside);

  useEffect(() => {
    if (editTool) {
      setColor(editTool.tool.color);
    } else {
      setColor("linear-gradient(140deg, rgb(198, 255, 221) 0%, rgb(251, 215, 134) 59%, rgb(247, 121, 125) 100%)");
    }
  }, [editTool]);

  const initialState = {
    title: editTool ? editTool.tool.title : "",
    link: editTool ? editTool.tool.link : "",
    color: "",
    icon: editTool ? editTool.tool.icon : "",
    features: editTool ? editTool.tool.features : [],
    dummyImage: editTool ? editTool.tool.dummyImage : "",
    oldImage: editTool ? editTool.tool.oldImage : "",
  };

  const formSchema = Yup.object({
    title: Yup.string().required("Title can not be empty"),
    // link: Yup.string().required("Link can not be empty"),
    icon: Yup.string().required("Please upload image"),
    features: Yup.array().min(1, "Please add feature"),
  });

  const handleSubmitlala = (values: any, { resetForm }: any) => {
    if (editTool) {
      setFieldValue(`tools[${editTool.index}]`, { ...values, color });
      resetForm();
      setShowPicker(false);
      setEditTool(null);
    } else {
      customHelpers.push({ ...values, color });
      setShowPicker(false);
      resetForm();
    }
  };

  // const handleUpload = (event: any, fieldValue: any, name: string) => {
  //   const data = {
  //     file: event.currentTarget.files[0],
  //   };
  //   uploadAction(data, fieldValue, name);
  // };

  const handleUpload = (event: any, fieldValue: any, name: string, oldImage: any) => {
    const formData = new FormData();
    formData.append("file", event.currentTarget.files[0]);
    formData.append("folder", "home-page");
    formData.append("url", oldImage ? oldImage : "");
    uploadNewAction(formData, fieldValue, name);
  };

  const onImageChange = useCallback((event: any, fieldValue: any, name: string, oldImage: any) => {
    if (event.target.files?.[0]) {
      const file = event.target.files[0];
      handleUpload(event, fieldValue, name, oldImage);
      const URL = window.URL || window.webkitURL;
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.src = objectUrl;
      img.onload = function handleImageLoad() {
        // fieldValue(name, event.target.files[0]);
        const reader = new FileReader();
        reader.onload = (e) => {
          fieldValue("dummyImage", e?.target?.result);
        };
        reader.readAsDataURL(event.target.files[0]);
      };
    }
  }, []);

  const handleRemove = useCallback((field: string, fieldValue: any) => {
    fieldValue(field, "");
    fieldValue("dummyImage", "");
  }, []);

  useEffect(() => {
    if (editTool) setColor(editTool?.tool?.color);
  }, [editTool]);

  return (
    <Formik enableReinitialize initialValues={initialState} validationSchema={formSchema} onSubmit={handleSubmitlala}>
      {({ values, handleChange, setFieldValue, handleBlur, errors, touched }) => {
        return (
          <Form>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fs-lg ">Add Tools Details</h6>
              </Card.Header>

              <Card.Body>
                <Row>
                  <Col lg="6">
                    <Row className="gy-3">
                      <Col lg="12">
                        <label className="form-label">Title</label>
                        <Field
                          name="title"
                          component={TextInput}
                          value={values.title}
                          onChange={handleChange}
                          onBlur={edit ? handleBlur : null}
                          placeholder="Enter Title"
                          className="editField"
                          readOnly={!edit}
                        />
                      </Col>
                      <Col lg="12">
                        <label className="form-label">Link</label>
                        <Field
                          name="link"
                          component={TextInput}
                          value={values.link}
                          onChange={handleChange}
                          onBlur={edit ? handleBlur : null}
                          placeholder="Enter Link"
                          className="editField"
                          readOnly={!edit}
                        />
                      </Col>

                      <Col lg="12">
                        <label className="form-label">Color Picker</label>
                        <div className="position-relative colorPickerInput">
                          <label className="colorLabel" onClick={() => edit && setShowPicker(!showPicker)} style={{ background: `${color}` }}></label>

                          <BForm.Control className="form-control" type="text" disabled></BForm.Control>
                          {/* <Button className="addBtn" onClick={() => edit && (showPicker ? handleAddAnimatedWord(setFieldValue, values) : setShowPicker(true))}>
                            +
                          </Button> */}

                          {showPicker && edit && (
                            <div className="colorPickerBox mt-50" ref={myRef}>
                              <ColorPicker value={color} onChange={setColor} />
                            </div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col lg="6">
                    {values.dummyImage || values.icon ? (
                      <div className="uploarForm position-relative nr-height">
                        {values.icon ? (
                          <>
                            {edit && (
                              <button
                                className="btn btn-danger btn-sm btn-icon position-absolute top-0 end-0 rounded me-2 mt-2 zindex-1"
                                onClick={() => {
                                  setFieldValue("oldImage", values?.icon);
                                  handleRemove("icon", setFieldValue);
                                }}
                              >
                                <i className="fa-regular fa-trash-can"></i>
                              </button>
                            )}

                            <img className="img-fluid" src={values.dummyImage || values.icon} alt="imagessss" />
                          </>
                        ) : (
                          <div className="position-absolute top-50 text-center w-100 translate-middle-y">
                            <SubmitLoader />
                          </div>
                        )}
                      </div>
                    ) : (
                      <>
                        <label className="form-label">Upload Icon</label>
                        <div className="uploarForm position-relative nr-height">
                          <i className="fa-light fa-upload fa-2x text-primary"></i>
                          <h6 className="mb-0 mt-3">Upload Images</h6>
                          {touched.icon && errors.icon ? <p className="errorMessage">{errors.icon}</p> : null}
                          <input
                            id="file"
                            name="icon"
                            type="file"
                            accept="image/x-png,image/gif,image/jpeg"
                            onChange={(e) => onImageChange(e, setFieldValue, "icon", values?.oldImage)}
                            disabled={!edit}
                            readOnly={!edit}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                </Row>

                <hr className="my-4" />

                <Row>
                  <FieldArray
                    name="features"
                    render={(arrayHelpers) => (
                      <Col sm="12">
                        <div className="d-flex align-items-center justify-content-between midHeader mb-3">
                          <h4 className="mb-0 title-sm">Toolbox</h4>
                          <button type="button" className="btn btn-green btn-sm" disabled={!edit} onClick={() => edit && setShowAddFeature(true)}>
                            <i className="fa-regular fa-plus"></i> Add Features
                          </button>

                          {showAddFeature && (
                            <AddFeatureModal
                              show={showAddFeature}
                              setShow={setShowAddFeature}
                              uploadAction={uploadAction}
                              customArrayHelper={arrayHelpers}
                              uploadNewAction={uploadNewAction}
                            />
                          )}
                        </div>

                        <div className="table-responsive cardTable">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th className="text-left contentTh">Feature Details</th>
                                <th className="text-center imageTh">Image</th>
                                <th className="text-center actionTh">Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {values.features.map((item: any, idx: number) => {
                                return (
                                  <FeauterItem
                                    key={item.title}
                                    item={item}
                                    arrayHelpers={arrayHelpers}
                                    uploadAction={uploadAction}
                                    setFieldValue={setFieldValue}
                                    idx={idx}
                                    uploadNewAction={uploadNewAction}
                                  />
                                );
                              })}
                            </tbody>
                          </table>
                          {touched.features && errors.features ? <p className="errorMessage">{`${errors.features}`}</p> : null}
                        </div>
                      </Col>
                    )}
                  />
                  <div className="d-flex align-items-center justify-content-center mt-4 mb-3">
                    {editTool ? (
                      <button
                        onClick={() => {
                          edit && setEditTool(null);
                        }}
                        className="btn btn-darkblue me-2"
                      >
                        Cancel
                      </button>
                    ) : null}
                    <button className="btn btn-green" type="submit" disabled={!edit}>
                      <i className="fa-regular fa-floppy-disk"></i> Save
                    </button>
                  </div>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
};
